export class WidgetSaldo {
    constructor(public billingPeriod: string,
                public billAmount: number,
                public balance: number,
                public balanceUpdateDatetime: string,
                public ownerFioMasked: string,
                public toPay: string,
                public billFileUrl: string,
                public accountId: string,
                public serviceName: string,
                public balanceStatus: string,
                public ownerEmail: string,
                public showEmail: boolean,
                public isEmailRequired: boolean,
                public isFromSite: boolean) {
    }
}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/main-page/account-part/widget-saldo.ts